import { useEffect, useRef } from "react"
import { WizardProvider, useWizard } from "@/components/wizard/WizardContext"
import WizardShell from "@/components/wizard/WizardShell"
import { getSatelliteImageUrl } from "@/hooks/useGoogleMaps"

function EstimatorInner() {
  const { state, setAddress, setRoofImage, nextStep } = useWizard()
  const initialized = useRef(false)

  // Pick up address from Home page if stored in sessionStorage
  useEffect(() => {
    if (initialized.current || state.step !== 1) return
    const stored = sessionStorage.getItem("estimator_address")
    if (!stored) return

    try {
      const data = JSON.parse(stored)
      setAddress(data.address, data.formattedAddress, data.lat, data.lng)
      setRoofImage(getSatelliteImageUrl(data.lat, data.lng))
      sessionStorage.removeItem("estimator_address")
      initialized.current = true
      // Auto-advance to roof drawing step
      nextStep()
    } catch {
      // ignore parse errors
    }
  }, [state.step, setAddress, setRoofImage, nextStep])

  return <WizardShell />
}

export default function Estimator() {
  return (
    <div className="flex-1 bg-gradient-to-b from-gray-50/50 to-white">
      <div className="max-w-xl mx-auto px-4 py-8 sm:py-12">
        <WizardProvider>
          <EstimatorInner />
        </WizardProvider>
      </div>
    </div>
  )
}
